var _path, _path2, _path3, _g, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterHeater(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8413_1047)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8413_1047",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 17.4375C12.9375 17.9553 12.5178 18.375 12 18.375C11.4822 18.375 11.0625 17.9553 11.0625 17.4375C11.0625 16.9197 11.4822 16.5 12 16.5C12.5178 16.5 12.9375 16.9197 12.9375 17.4375Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8413_1047)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8413_1047",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8413_1047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3125 11.5313V3.75C19.3125 2.19671 18.0533 0.937502 16.5 0.937502H7.5C5.9467 0.937502 4.6875 2.19671 4.6875 3.75V17.4375C4.6875 18.9908 5.9467 20.25 7.5 20.25H16.5C18.0533 20.25 19.3125 18.9908 19.3125 17.4375V16.5",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 20.3438V23.0625",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4219 20.3438V23.0625",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0645 6.9209C12.3419 7.3018 12.711 7.82528 13.0791 8.39844C13.4484 8.97349 13.8107 9.59005 14.0791 10.1562C14.3562 10.7409 14.5 11.2049 14.5 11.5C14.5 12.8807 13.3807 14 12 14C10.6193 14 9.5 12.8807 9.5 11.5C9.5 11.2049 9.64378 10.7409 9.9209 10.1562C10.1893 9.59005 10.5516 8.97349 10.9209 8.39844C11.289 7.82528 11.6581 7.3018 11.9355 6.9209C11.9574 6.89088 11.9793 6.86216 12 6.83398C12.0207 6.86216 12.0426 6.89088 12.0645 6.9209Z",
    stroke: "#D85263"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8413_1047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterHeater);
export default __webpack_public_path__ + "static/media/water-heater.9877eaa92fb71d7a41cdf6b86ededc8a.svg";
export { ForwardRef as ReactComponent };